import { useTranslation } from 'react-i18next'
import { generatePath } from 'react-router-dom'

import { RelatedList, RelatedListItem, RelatedSettings } from 'components/RelatedSettings'
import { useWorkspaceParam } from 'features/workspace/hooks/useWorkspaceParam'
import { ROUTES } from 'routes'
import { WorkspaceDefaults } from '../useGetWorkspaceDefaults'

export const BasicSettingsWorkspaceDefaults = ({
  workspaceDefaults,
}: {
  workspaceDefaults: WorkspaceDefaults
}): React.JSX.Element => {
  const { t: tc } = useTranslation('common')
  const { t } = useTranslation('features/domain', {
    keyPrefix: 'form.richPlacements.multiAnchor.workspaceDefaults',
  })
  const { workspaceId } = useWorkspaceParam()

  const { displayAfterUserInteraction, frequencyCappingEnabled, singleAdViewTime } =
    workspaceDefaults

  return (
    <RelatedSettings title={t('title')}>
      <RelatedList>
        <RelatedListItem
          content={t('singleAdViewTime')}
          url={generatePath(ROUTES.GLOBAL_SETUP.DEFAULTS.ROOT, {
            section: 'multi-anchor',
            tab: 'rich-placements',
            workspaceId,
          })}
          value={singleAdViewTime.toLocaleString()}
        />

        <RelatedListItem
          content={t('displayAfterUserInteraction')}
          value={tc(`booleanState.${displayAfterUserInteraction}`)}
        />
        {frequencyCappingEnabled !== undefined && (
          <RelatedListItem
            content={t('frequencyCappingEnabled')}
            value={tc(`booleanState.${frequencyCappingEnabled}`)}
          />
        )}
      </RelatedList>
    </RelatedSettings>
  )
}
